var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('div', {
    staticClass: "form-group row smart-input-marker"
  }, [_c('b-input-group', {
    staticClass: "col-md-8",
    staticStyle: {
      "margin-top": "-20px"
    }
  }, [_c('span', {
    ref: "dummyInput",
    staticClass: "form-control dummy-input-box"
  }, [_vm._v("\n      " + _vm._s(_vm.styleData.shipment) + "\n    ")])])], 1) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36f2eb94","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/common/smartInput.vue
// module id = 1039
// module chunks = 1